import './bootstrap';
import '../css/app.css';
import { createApp } from 'vue';
import App from './components/App.vue';
import router from './router';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

const app = createApp(App);

const BrandPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#f3fcfc',
            100: '#e3f8f7',
            200: '#bff3f1',
            300: '#8feae7',
            400: '#53dfda',
            500: '#26b7ba',
            600: '#1d9a96',
            700: '#1b928e',
            800: '#167471',
            900: '#115a58',
            950: '#0c3735',
        },
    },
});

app.use(PrimeVue, {
    theme: {
        preset: BrandPreset,
        options: {
            ripple: true,
            // prefix: 'p',
            darkModeSelector: 'light',
        },
    },
});

app.use(router);

app.mount("#app");
